import { FiveHundered } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';
import { Link, useParams } from 'react-router-dom';

import styles from './ErrorsPage.module.scss';
interface Props {
  pageStatus?: string;
}
const ErrorsPage: FunctionComponent<Props> = ({ pageStatus }) => {
  const errorsMap = {
    '404': {
      title: _t('basic:page_not_found'),
      desc: _t('basic:page_not_found_des'),
    },
    '401': {
      title: _t('basic:you_are_not_authorize'),
      desc: _t('basic:page_not_authorize'),
    },
    '500': {
      title: _t('basic:something_went_wrong'),
      desc: _t('basic:something_went_wrong_des'),
    },
    '502': {
      title: _t('basic:something_went_wrong'),
      desc: _t('basic:something_went_wrong_des'),
    },
  };

  const { status }: { status: keyof typeof errorsMap } = useParams();
  const statusKey = status || pageStatus;

  return (
    <div className={styles.ErrorsPage}>
      <h1>{statusKey.includes('40') ? statusKey : <FiveHundered />}</h1>
      <h4>{errorsMap[statusKey].title}</h4>
      <p>{statusKey.includes('40') && errorsMap?.[statusKey]?.desc}</p>
      <Link to="/">{_t('basic:back_to_home')}</Link>
    </div>
  );
};

export default ErrorsPage;
